export default __webpack_public_path__ + "static/media/image2.3e0be971.jpg";